export enum CalculatorActionTypes {
    SET_ALL_CALCULATOR_FIELDS = 'SET_ALL_CALCULATOR_FIELDS',
    SET_CALCULATOR_MANAGER_PAGE = 'SET_CALCULATOR_MANAGER_PAGE',
    FETCH_CALCULATOR_PROMPT_EXAMPLES_STARTED = 'FETCH_CALCULATOR_PROMPT_EXAMPLES_STARTED',
    FETCH_CALCULATOR_PROMPT_EXAMPLES_SUCCESSFUL = 'FETCH_CALCULATOR_PROMPT_EXAMPLES_SUCCESSFUL',
    FETCH_CALCULATOR_PROMPT_EXAMPLES_FAILED = 'FETCH_CALCULATOR_PROMPT_EXAMPLES_FAILED',
    UPSERT_CALCULATOR_PROMPT_STARTED = 'UPSERT_CALCULATOR_PROMPT_STARTED',
    UPSERT_CALCULATOR_PROMPT_SUCCESSFUL = 'UPSERT_CALCULATOR_PROMPT_SUCCESSFUL',
    UPSERT_CALCULATOR_PROMPT_FAILED = 'UPSERT_CALCULATOR_PROMPT_FAILED',
    DELETE_CALCULATOR_PROMPT_STARTED = 'DELETE_CALCULATOR_PROMPT_STARTED',
    DELETE_CALCULATOR_PROMPT_SUCCESSFUL = 'DELETE_CALCULATOR_PROMPT_SUCCESSFUL',
    DELETE_CALCULATOR_PROMPT_FAILED = 'DELETE_CALCULATOR_PROMPT_FAILED',
    UPDATE_SELECTED_CALCULATOR_PROMPT = 'UPDATE_SELECTED_CALCULATOR_PROMPT',
    TOGGLE_DELETE_CALCULATOR_PROMPT_CONFIRMATION_MODAL = 'TOGGLE_DELETE_CALCULATOR_PROMPT_CONFIRMATION_MODAL',
    SET_SELECTED_CALCULATOR_PROMPT_UPDATED = 'SET_SELECTED_CALCULATOR_PROMPT_UPDATED',
    SELECT_CALCULATOR_PROMPT = 'SELECT_CALCULATOR_PROMPT',
    TOGGLE_CALCULATOR_PAD_OPTIONS_MODAL = 'TOGGLE_CALCULATOR_PAD_OPTIONS_MODAL',
    SELECT_CALCULATOR_PAD_OPTION = 'SELECT_CALCULATOR_PAD_OPTION',
    UPDATE_CALCULATOR_PAD_OPTION_VALUE = 'UPDATE_CALCULATOR_PAD_OPTION_VALUE',
    SET_PAD_OPTION_HAS_UPDATED = 'SET_PAD_OPTION_HAS_UPDATED',
    UPSERT_CALCULATOR_PAD_OPTION_STARTED = 'UPSERT_CALCULATOR_PAD_OPTION_STARTED',
    UPSERT_CALCULATOR_PAD_OPTION_SUCCESSFUL = 'UPSERT_CALCULATOR_PAD_OPTION_SUCCESSFUL',
    UPSERT_CALCULATOR_PAD_OPTION_FAILED = 'UPSERT_CALCULATOR_PAD_OPTION_FAILED',
    SELECT_CALCULATOR_FIELD_TYPE = 'SELECT_CALCULATOR_FIELD_TYPE',
    UPDATE_CALCULATOR_FIELD_TYPE_VALUE = 'UPDATE_CALCULATOR_FIELD_TYPE_VALUE',
    SET_FIELD_TYPE_HAS_UPDATED = 'SET_FIELD_TYPE_HAS_UPDATED',
    UPSERT_CALCULATOR_FIELD_TYPE_STARTED = 'UPSERT_CALCULATOR_FIELD_TYPE_STARTED',
    UPSERT_CALCULATOR_FIELD_TYPE_SUCCESSFUL = 'UPSERT_CALCULATOR_FIELD_TYPE_SUCCESSFUL',
    UPSERT_CALCULATOR_FIELD_TYPE_FAILED = 'UPSERT_CALCULATOR_FIELD_TYPE_FAILED',
    TOGGLE_CALCULATOR_FIELD_TYPE_PREVIEW_VIEW = 'TOGGLE_CALCULATOR_FIELD_TYPE_PREVIEW_VIEW',
    SET_CALCULATOR_PROMPT_ORDER = 'SET_CALCULATOR_PROMPT_ORDER',
    UPDATE_CALCULATOR_PROMPT_ORDER = 'UPDATE_CALCULATOR_PROMPT_ORDER',
    SAVE_PROMPT_ORDER_STARTED = 'SAVE_PROMPT_ORDER_STARTED',
    SAVE_PROMPT_ORDER_SUCCESSFUL = 'SAVE_PROMPT_ORDER_SUCCESSFUL',
    SAVE_PROMPT_ORDER_FAILED = 'SAVE_PROMPT_ORDER_FAILED'
}

export enum CalculatorManagerPage {
    SELECT = 'select',
    PROMPTS = 'Calculator Prompts',
    MANAGER = 'Calculator Field Manager'
}

export enum CalculatorOptionType {
    DROPDOWN = 'dropdown',
    NUMBER = 'number',
    DECIMAL = 'decimal',
    STANDARD = 'standard',
    TEXT = 'text',
    DATE = 'date'
}

export enum CalculationType {
    OUTPUT = 'output',
    GRACE_PERIOD = 'gracePeriod'
}

export enum LogicalOperator {
    AND = 'AND',
    OR = 'OR'
}

export enum CalculationCondition {
    IF = 'IF',
    ELSE_IF = 'ELSE IF',
    ELSE = 'ELSE'
}

export interface CalculatorInput {
    type: string;
    label: string;
    value: string;
}

export type CalculationBuilder = CalculatorInput[];

export interface InitialCalculation {
    index: 0;
    builder: CalculationBuilder;
}

export interface AdditionalCalculation {
    index: number;
    builder: CalculatorInput[];
    condition: LogicalOperator | null;
}

export type Calculation = InitialCalculation | AdditionalCalculation;

export interface CalculatorField {
    calculationCondition: CalculationCondition | null;
    output: CalculationBuilder;
    calculation: Calculation[];
    gracePeriod: CalculationBuilder;
}

export interface CalculatorPadOptionConfig {
    fontSize: string;
    inputFontSize: string;
    dropdownName?: string;
}

export interface CalculatorPadOptionDB {
    calculatorPadOptionId: number;
    inputType: string;
    label: string;
    description: string;
    type: CalculatorOptionType;
    config: CalculatorPadOptionConfig;
}

export interface CalculatorPadOptionUI {
    calculatorPadOptionId?: number;
    inputType: string;
    label: string;
    description: string;
    type: CalculatorOptionType;
    config: CalculatorPadOptionConfig;
}

export interface CalculatorFieldTypeDB {
    calculatorFieldTypeId: number;
    name: string;
    description: string;
    buildPadOptions: number[];
    outputPadOptions: number[];
    gracePeriodPadOptions: number[];
    includeOutput: number;
    includeGracePeriod: number;
    includeOther: number;
    includeConditionals: number;
    includeIfElse: number;
}

export interface CalculatorFieldTypeUI {
    calculatorFieldTypeId?: number;
    name: string;
    description: string;
    buildPadOptions: number[];
    outputPadOptions: number[];
    gracePeriodPadOptions: number[];
    includeOutput: number;
    includeGracePeriod: number;
    includeOther: number;
    includeConditionals: number;
    includeIfElse: number;
}

export interface CalculatorPromptDB {
    promptId: number;
    calculatorFieldType: string;
    calculationText: string;
    calculation: CalculatorField[];
    priorityOrder: number;
    createdBy: number;
    createdByUsername: string;
    createdDate: string;
    clientId?: number;
    isSystem: boolean;
}

export interface CalculatorPromptUI {
    promptId?: number;
    calculatorFieldType: string | null;
    calculationText: string;
    calculation: CalculatorField[];
    priorityOrder: number;
    isSystem: boolean;
}

export interface CalculatorPromptPriorityOrder {
    promptId: number;
    priorityOrder: number;
}

export interface CalculatorState {
    calculatorManagerPage: CalculatorManagerPage;
    calculatorFields: CalculatorFieldTypeDB[];
    padOptions: CalculatorPadOptionDB[];
    padOptionsModalOpen: boolean;
    currentCalculatorField: CalculatorFieldTypeUI | null;
    savedCalculatorField: CalculatorFieldTypeUI | null;
    currentPadOption: CalculatorPadOptionUI | null;
    savedPadOption: CalculatorPadOptionUI | null;
    calculatorFieldHasUpdated: boolean;
    padOptionHasUpdated: boolean;
    isFetchingCalculatorPrompts: boolean;
    isSavingCalculatorPrompt: boolean;
    isDeletingCalculatorPrompt: boolean;
    calculatorPrompts: CalculatorPromptDB[];
    selectedCalculatorPrompt: CalculatorPromptUI | null;
    calculatorPromptToDelete: CalculatorPromptDB | null;
    selectedPromptUpdated: boolean;
    showCalculatorPreview: boolean;
    currentSelectedFieldTypePromptOrder: CalculatorPromptDB[];
    savedSelectedFieldTypePromptOrder: CalculatorPromptDB[];
}
